import './MultiSelectList.158aef3b006276dfed5130e87891a119.css';
export default {"layout":"_layout_etpmv_1","section":"_section_etpmv_1"};